import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { UserRecommendationHighlight } from "@/schemas/user/explore";
import { Spacings } from "@/styling/spacings";
import { themes } from "@/Components/Styling/themeConfigs";
import { toReadableText } from "@/formatting/text";
import { EXPLORE_CONSTANTS, getHighlightEmoji } from "@/utils/explore";

type Props = {
  highlights: UserRecommendationHighlight[];
  isLargeCard?: boolean;
};

function CompatibilityHighlights({
  highlights,
  isLargeCard = false,
}: Props): React.JSX.Element {
  if (!highlights || highlights.length === 0) {
    return <></>;
  }

  return (
    <View
      style={[
        styles.container,
        // { flexDirection: isLargeCard ? "row" : "column" },
      ]}
    >
      {highlights
        .sort((a, b) => a.rank - b.rank)
        .slice(
          0,
          isLargeCard
            ? EXPLORE_CONSTANTS.MAX_HIGHLIGHTS_LARGE_CARD
            : EXPLORE_CONSTANTS.MAX_HIGHLIGHTS_SMALL_CARD,
        )
        .map((item) => (
          <View
            key={`${item.type}-${item.rank}`}
            style={[
              styles.semiTransparentBackgroundBorder,
              {
                paddingVertical: isLargeCard ? Spacings.s2 : Spacings.s1 * 1.5,
                paddingHorizontal: isLargeCard
                  ? Spacings.s2
                  : Spacings.s1 * 1.5,
              },
            ]}
          >
            <Text style={styles.highlightText}>
              {getHighlightEmoji(item.type)}
              {toReadableText(item.type)}
            </Text>
          </View>
        ))}
    </View>
  );
}

const currentTheme = themes.morning;

const styles = StyleSheet.create({
  container: {
    maxWidth: "69%",
    flexDirection: "column",
    alignItems: "flex-start",
    flexWrap: "wrap",
    columnGap: Spacings.s1,
    rowGap: Spacings.s1,
  },
  semiTransparentBackgroundBorder: {
    backgroundColor: "rgba(85, 85, 85, 0.75)",
    borderRadius: 30,
  },
  highlightText: {
    color: "#ffffff",
    fontSize: currentTheme.typography.body.size.mobile - 3,
    fontWeight: "bold",
    textAlign: "center",
    textShadowColor: "rgba(0, 0, 0, 0.5)",
    textShadowOffset: { width: 0, height: 0.5 },
    textShadowRadius: 1,
  },
});

export default CompatibilityHighlights;
